import type { DeviceApplication as DeviceApplicationModel } from '@/adapters/catalogv1.g';

export function extractDeviceApplication(model: DeviceApplicationModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deviceRef: model.device_ref ?? '',
    applicationRef: model.application_ref ?? '',
    isApproved: model.is_approved,
    version: model.version,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogDeviceApplication = ReturnType<
  typeof extractDeviceApplication
>;
